import type React from 'react';
import { Box, Text } from '@nimbus-ds/components';
import { MoneyDto } from '@tiendanube/common';
import { DataList } from '@tiendanube/components';
import { Money } from 'commons/components';
import { SettledAmount } from '../../../../../../../components';

interface AmountRowProps {
  readonly id: string;
  readonly title: string;
  readonly amount: MoneyDto;
  readonly isStrong?: boolean;
  readonly isNegative?: boolean;
  readonly hideIfZero?: boolean;
}

function AmountRow({
  id,
  title,
  amount,
  isStrong = false,
  isNegative = false,
  hideIfZero = false,
}: Readonly<AmountRowProps>): React.JSX.Element | null {
  const { value, currency, settledAmount, isError } = amount;

  const numericValue = Number(value);

  if (hideIfZero && numericValue === 0) {
    return null;
  }

  const computedPrice =
    isNegative && numericValue !== 0 ? -Math.abs(numericValue) : numericValue;

  return (
    <DataList.Row id={id} grayed={isStrong}>
      <DataList.Cell width={70}>
        <Box display="flex" flexDirection="row" gap="0-5">
          <Text
            color="neutral-textHigh"
            fontWeight={isStrong ? 'bold' : undefined}
          >
            {title}
          </Text>
        </Box>
      </DataList.Cell>
      <DataList.Cell width={30}>
        <Box display="flex" flexDirection="column" alignItems="flex-end">
          {isError ? (
            <Text
              color="neutral-textHigh"
              fontWeight={isStrong ? 'bold' : undefined}
            >
              -
            </Text>
          ) : (
            <>
              <Money
                price={computedPrice}
                currency={currency}
                textAlign="right"
                fontWeight={isStrong ? 'bold' : undefined}
                color={isNegative ? 'danger-textLow' : 'neutral-textHigh'}
              />
              {settledAmount && <SettledAmount amount={settledAmount} />}
            </>
          )}
        </Box>
      </DataList.Cell>
    </DataList.Row>
  );
}

export default AmountRow;
